export class UserSecurityGroup {
    public securityGroup_Id: string = null;
    public name: string = null;
}
